import { useState } from "react";
import { Card, CardHeader, CardContent,  Avatar, Typography, Box, Button,  CircularProgress, Dialog, DialogTitle, DialogContent } from "@mui/material";
import PostDisplay from "./PostDisplay";
import PublicIcon from '@mui/icons-material/Public';
import { useUser } from "./UserProvider";
import DesignEditorInChat from "./DesignEditorInChat";
import { TemplateGallery } from "./TemplateSelectorModalInfinite";
import { req, reqPoll } from "./ServerUtils";

export function LinkedinPostPreview({text, carousel, postType='text', setText, post, setCarousel, conversationId}) {
    const {userInfo} = useUser();

    return (
    <Card sx={{boxShadow: 'none'}}>
        <CardHeader
            avatar={<Avatar sx={{ width: 48, height: 48 }}>
                <img src={userInfo?.info?.profile_pic_cropped || "/images/avatar.jpg"} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </Avatar>}
            title={
                <Box>
                    <Typography variant="subtitle1" component="span" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
                        {userInfo?.info?.name}
                    </Typography>
                    <Typography variant="body2" component="span" color="text.secondary" sx={{ ml: 1 }}>
                        • 1st
                    </Typography>
                </Box>
            }
            subheader={
                <Box sx={{ mt: -0.8, lineHeight: 1.2 }}>
                    <Typography variant="caption" color="text.secondary">
                    {userInfo?.info?.description}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', mt: -0.2 }}>
                    <Typography variant="caption" color="text.secondary">4h</Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ mx: 0.5 }}>•</Typography>
                    <PublicIcon fontSize="small" sx={{ fontSize: 14, color: 'text.secondary' }} />
                    </Box>
                </Box>
            }
            
        />
        <CardContent sx={{
                height: "90%",
                overflowY: 'auto'
        }} style={{
            padding: 10
        }}>
            <PostDisplay text={text} setText={setText} postType={postType} />
            {carousel && <DesignEditorInChat 
                id={carousel.design_id} 
                postActions = {<PostActions post={post} carousel={carousel} setCarousel={setCarousel} conversationId={conversationId} />}
            />}
            {!carousel && <PostActions post={post} carousel={carousel} setCarousel={setCarousel} conversationId={conversationId} />}
        </CardContent>
    </Card>
    );
}


function PostActions({post, carousel, setCarousel, conversationId}) {
    const [showCarouselDialog, setShowCarouselDialog] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [loading, setLoading] = useState(false);
    
    function setFinished() {
      setLoading(false);
      setShowCarouselDialog(false);
    }
  
    return (
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        gap: 20
      }}>
        <Button variant="outlined" color="primary" onClick={() => setShowCarouselDialog(true)} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "Attach Carousel"}
        </Button>
        {/* <PostCalendar post={post} schedule={schedulePost} loading={loading} setLoading={setLoading} carousel={carousel}/> */}
        
        <Dialog open={showCarouselDialog} onClose={() => setShowCarouselDialog(false)} >
          <DialogTitle>Attach Carousel</DialogTitle>
          <DialogContent sx={{
            p: 0
          }}>
              <TemplateGallery selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} isOpen={showCarouselDialog} setStep={(s)=> {
                if (s == "template-selected") {
                  generate({selectedTemplate, post: post, setCarousel, setLoading, setFinished, conversationId});
                }
                setShowCarouselDialog(false);
              }} cats={[{
                name: 'Carousel',
                value: 'mako-carousel'
              }, {
                name: 'Quote',
                value: 'mquote'
              }, {
                name: 'Iceberg',
                value: 'miceberg'
              }, {
                name: 'Cheatsheet',
                value: 'mcheatsheet'
              }]} />
          </DialogContent>
        </Dialog>
      </div>
    )
  }



function generate({selectedTemplate, post, setCarousel, setLoading, setFinished, conversationId}) {
    setLoading(true);
    reqPoll('/generate', 'POST', JSON.stringify({
        template_id: selectedTemplate.id,
        blogpost: post.join('\n'),
        language: "english",
        formats: [],
        html_only: true,
        force_fetch: true
    })).then(res => {
        console.log("Generation response", res);
        if (res.design_id) {
          setCarousel({
            urls: res.urls,
            design_id: res.design_id,
            pdf_url: res.pdf_url,
          });
          req(`/conversation-metadata/${conversationId}`, 'POST', JSON.stringify({
            carousel: res,
          }));
        }
        setFinished(true);
    }).catch(error => {
      console.log('Error generating: ', error);
      setFinished(true);
    });
  }


  